import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
	filterContainer: {
		marginTop: '3rem',
		border: '2px solid red',
		width: '100%'
	},
	heading: {
		fontWeight: '600',
		color: '#FC4B58',
		width: '100%',
		padding: 0,
		textAlign: 'left',
		margin: '0 auto !important'
	},
	sectionContainer: {
		marginTop: '5rem',
		height: '9rem',
		maxHeight: '60rem',
		overflow: 'auto',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		padding: '2.3rem 2.3rem 1rem 2.3rem'
	}
}));
